import React, { useCallback } from 'react';
import { isSameDay, isSameMonth, isSameYear } from 'date-fns';
import { DatePicker } from '@ihsm/ui-shared';
import './DatePicker.scss';
import { DatePickerProps } from '../types';

export const DatePickerContainer: React.FC<DatePickerProps> = ({
  valuationDate = new Date(),
  valuationDateList = [],
  labelText = 'Date',
  onChange,
}): JSX.Element => {
  const onChangeHandler = (value: Date) => {
    if (onChange) {
      onChange(value);
    }
  };

  const tileDisabled = useCallback(
    ({ date }: { date: Date }): boolean => {
      return !valuationDateList.some(
        (valDate) =>
          isSameDay(valDate, date) &&
          isSameMonth(valDate, date) &&
          isSameYear(valDate, date)
      );
    },
    [valuationDateList]
  );

  return (
    <DatePicker
      labelText={labelText}
      value={valuationDate}
      onChange={onChangeHandler}
      tileDisabled={tileDisabled}
      verticalLayout
    />
  );
};
